// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XJ0s8","index":"styles_index__2lAzG"};